<template lang="html">

  <b-container fluid>

    <b-row>
        <b-col md="6" offset-md="3" align-self="center"  d-flex h-100 flex-wrap >

          <b-img src="../assets/480x320-blade.png" center fluid alt="Responsive image" style=" margin-top:5%"/>
          <b-card v-if="!success" title="Change Password"  sub-title="" style="blade-blue margin-top:3%">
          <!-- <h3 class="blade-blue">{{dynamictitle}}</h3> -->
          <form role="form" v-on:submit.prevent="showAndSubmitLicenseAgreement()"  v-if="!busy && !success">
                            <fieldset>

                                <!-- <div class="form-group">
                                     <button  class="btn btn-lg btn-blade btn-block">Resend Access Token </button>
                                  </div> -->
                                <div class="form-group">
                                  <input v-model="$v.form.accessToken.$model"  aria-describedby="accessTokenInput"  class="form-control" placeholder="Verification Code" name="accesstoken" type="text">
                                  <b-alert variant="danger"  :show="($v.form.accessToken.$dirty && $v.form.accessToken.$invalid)">
                                    <p>Field is required</p>
                                    <p>Min 6 numbers</p>
                                    </b-alert>
                                </div>

                                <div class="form-group">
                                  <input v-model="$v.form.userName.$model" aria-describedby="usernameInput"  class="form-control" placeholder="Username" name="username" type="text">
                                     <b-alert variant="danger"  :show="($v.form.userName.$dirty && !$v.form.userName.required)">Field is required</b-alert>
                                </div>

                                <div class="form-group">
                                    <input v-model="$v.form.password.$model"  aria-describedby="passwordInput"  class="form-control" placeholder="New Password" name="email" type="password">
                                     <b-alert variant="danger"  id="passwordInput" :show="($v.form.password.$dirty && !$v.form.password.strongPassword)">
        <p>The string must contain at least 1 lowercase alphabetical character</p>
        <p>The string must contain at least 1 uppercase alphabetical character</p>
        <p>The string must contain at least 1 numeric character</p>
        <p>The string must be eight characters or longer</p>
      </b-alert>
                                </div>
                                <div class="form-group">
                                    <input  v-model="$v.form.confirmPassword.$model" aria-describedby="passwordInput"   class="form-control" placeholder="Confirm New Password" name="password" type="password" :class="status($v.form.password)">
                                                                         <b-alert variant="danger" id="confirmPasswordInput" :show="($v.form.confirmPassword.$dirty && !$v.form.confirmPassword.sameAsPassword)">
        passwords don't match
      </b-alert>
                                </div>

                                <div class="form-group">
                                  <label class="left-align">
                                    <input class="center-align" type="checkbox" name="privacyPolicy" v-model="$v.form.privacyPolicy.$model">
                                    I have read and agree to the <a class="aMargin" v-on:click.prevent="showLicenseAgreement()" href="#">User Agreement</a> and <a class="aMargin" v-on:click.prevent="showPrivacyPolicy()" href="#"> Privacy Policy.</a>
                                  </label>
                                </div>

                                <!-- Change this to a button or input when using this as a form -->
                                <button type="submit" class="btn btn-lg btn-blade btn-block" v-bind:disabled="$v.form.$invalid">Update</button>

                            </fieldset>
                        </form>

                          <div class="loader"> <stretch v-if="busy" ></stretch> </div>
            </b-card>
        </b-col>
    </b-row>
    <b-row>
      <b-col md="4" offset-md="4" align-self="center"  d-flex h-100 flex-wrap >
          <b-alert :show="hasError" variant="danger" @dismissed="hasError=false">  {{errorMsg}}
          </b-alert>

             <b-alert :show="success" variant="success" @dismissed="hasError=false">
              Your password has been updated.
              <br/>
             <!-- <b-link :to="'/'">Login</b-link> -->
          </b-alert>
                 <!-- <b-link :to="'/'" v-if="!success">Cancel</b-link> -->
      </b-col>
    </b-row>
    <b-row>
      <b-col md="4" offset-md="4" align-self="center"  d-flex h-100 flex-wrap v-if="success">
          <button v-on:click="navigateToHomePage" class="btn btn-lg btn-blade btn-block">Login</button>
      </b-col>
    </b-row>
    <div slot="footer" class="w-100">
      <license-footer></license-footer>
    </div>
</b-container>
</template>

<script lang="js">

import { Stretch } from 'vue-loading-spinner'
import { required, sameAs, minLength, numeric, helpers } from 'vuelidate/lib/validators'
import LicenseFooter from './LicenseFooter'
import { CODE_MISMATCH_EXCEPTION, CODE_MISMATCH_EXCEPTION_MSG, EXPIRED_CODE_EXCEPTION,
         EXPIRED_CODE_EXCEPTION_MSG, USER_NOT_FOUND_EXCEPTION, USER_NOT_FOUND_CHPASS_EXCEPTION_MSG } from '../../src/constants'

const strongPassword = helpers.regex('strongPassword', /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})/)

export default {
  name: 'change-password',
  components: { Stretch, LicenseFooter },
  props: [],
  mounted () {
    const self = this
    self.$eventBus.$once('license-agreement-accepted-cp', () => {
      self.update()
    })
  },
  data () {
    return {
      busy: false,
      hasError: false,
      errorMsg: '',
      success: false,
      form: {

        accessToken: '',
        userName: '',
        password: '',
        confirmPassword: '',
        privacyPolicy: false
      }
    }
  },
  validations: {

    form: {

      accessToken: {
        numeric,
        minLength: minLength(6)
      },

      userName: {

        required
      },
      password: {
        required,
        strongPassword
      },
      confirmPassword: {
        sameAsPassword: sameAs('password')
      },
      privacyPolicy: {
        sameAs: sameAs(() => true)
      }
    }
  },
  methods: {
    navigateToHomePage () {
      this.$router.push('/')
    },

    update () {
      const self = this
      let accessToken = self.form.accessToken.trim()
      let userName = self.form.userName.trim()
      let password = self.form.password.trim()

      self.hasError = false
      self.busy = true
      self.$auth.changePassword(accessToken, userName, password).then(response => {
        self.busy = false
        self.success = true
      })
        .catch(err => {
          self.hasError = true
          self.busy = false

          if (err.response && err.response.data === CODE_MISMATCH_EXCEPTION) {
            self.errorMsg = CODE_MISMATCH_EXCEPTION_MSG
          } else if (err.response && err.response.data === EXPIRED_CODE_EXCEPTION) {
            self.errorMsg = EXPIRED_CODE_EXCEPTION_MSG
          } else if (err.response && err.response.data === USER_NOT_FOUND_EXCEPTION) {
            self.errorMsg = USER_NOT_FOUND_CHPASS_EXCEPTION_MSG
          }
           else {
            self.errorMsg = 'Error occurred. Please try again.'
          }
          self.$eventBus.$once('license-agreement-accepted-cp', () => {
            self.update()
          })
        })
    },
    status (validation) {
      console.log(`error: ${validation.$error}`)
      console.log(`dirty: ${validation.$dirty}`)
      console.log(`strong: ${validation.strongPassword}`)
      return {
        error: validation.$error,
        dirty: validation.$dirty
      }
    },
    showPrivacyPolicy () {
      this.$eventBus.$emit('show-privacy-policy')
    },
    showLicenseAgreement () {
      this.$eventBus.$emit('show-license-agreement')
    },
    showAndSubmitLicenseAgreement () {
      this.$eventBus.$emit('show-license-agreement', 'Accept', 'cp')
    }

  },
  computed: {

    /* dynamictitle() {
        if (!this.success)
        {
          return 'Change Password'
        }else{
          return ''
        }
      } */
  }
}
</script>

<style src="../assets/styles.css">

</style>



// WEBPACK FOOTER //
// src/components/ChangePassword.vue